__turbopack_context__.v({
  "circle": "-7-UPW_circle",
  "container": "-7-UPW_container",
  "svg": "-7-UPW_svg",
});
